import { PluginInterface } from '../types/PluginInterface';

class PluginRegistry {
  private plugins: Map<string, PluginInterface> = new Map();
  // Une liste de fonctions à appeler quand le registre change
  private subscribers: Set<() => void> = new Set();

  register(plugin: PluginInterface) {
    if (!plugin || !plugin.metadata || !plugin.metadata.id) {
      console.error('Tentative d\'enregistrement d\'un plugin invalide:', plugin);
      return;
    }
    if (this.plugins.has(plugin.metadata.id)) {
      return; // Déjà enregistré
    }
    this.plugins.set(plugin.metadata.id, plugin);
    // Notifier tous les composants qui écoutent
    this.notifySubscribers();
  }

  /** Comme register() mais écrase toujours l'entrée existante (pour les plugins utilisateur). */
  upsert(plugin: PluginInterface) {
    if (!plugin || !plugin.metadata || !plugin.metadata.id) {
      console.error('Tentative d\'upsert d\'un plugin invalide:', plugin);
      return;
    }
    this.plugins.set(plugin.metadata.id, plugin);
    this.notifySubscribers();
  }

  get(id: string): PluginInterface | undefined {
    if (this.plugins.has(id)) {
      return this.plugins.get(id);
    }
    if (id === 'video-modular') {
      return this.plugins.get('audio-player-advanced');
    }
    return undefined;
  }

  getAll(): PluginInterface[] {
    return Array.from(this.plugins.values());
  }

  // Méthode pour qu'un composant s'abonne aux changements
  subscribe(callback: () => void) {
    this.subscribers.add(callback);
  }

  // Méthode pour se désabonner (très important pour éviter les fuites de mémoire)
  unsubscribe(callback: () => void) {
    this.subscribers.delete(callback);
  }

  // Fonction privée pour appeler tous les abonnés
  private notifySubscribers() {
    this.subscribers.forEach(callback => callback());
  }
}

export const pluginRegistry = new PluginRegistry();
